import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import {
  DeliveryNoteHandlingUnits,
  DeliveryNoteHandlingUnitsInitialState,
} from './delivery-note-handling-units.actions';
import {
  DeliveryNoteHandlingUnitsState,
  DeliveryNoteHandlingUnitsStateModel,
} from './delivery-note-handling-units.state';
import {
  DeliveryNoteHandlingUnitSearchCriteria,
  DeliveryNoteHandlingUnitModel,
  DeliveryNoteParams,
} from '../../../models';
import { ListQueryParam, LoadDataFacade, SetInitialStateFacade } from '../../../../../../common';
import { DeliveryNoteItemFacade } from '../../delivery-note-item.facade';
import { CatalogSearchCriteriaFacade, CatalogSearchCriteriaType } from '../../../../catalog-search-criteria';
import { AutomotiveAftermarketSearchCriteria } from '../../../../monitoring/automotive-aftermarket';
import { take } from 'rxjs/operators';
import { MonitoringFilterNameDictionary } from '../../../../../models';

@Injectable({ providedIn: 'root' })
export class DeliveryNoteHandlingUnitsFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<DeliveryNoteHandlingUnitsStateModel> = this.store.select(
    DeliveryNoteHandlingUnitsState.getState,
  );
  items$: Observable<DeliveryNoteHandlingUnitModel[]> = this.store.select(DeliveryNoteHandlingUnitsState.getItems);
  loaded$: Observable<boolean> = this.store.select(DeliveryNoteHandlingUnitsState.getLoaded);

  constructor(
    private store: Store,
    private deliveryNoteItemFacade: DeliveryNoteItemFacade,
    private catalogSearchCriteriaFacade: CatalogSearchCriteriaFacade,
  ) {}

  loadAll(initialFetch: boolean = true, filterFormSearchCriteria?: DeliveryNoteHandlingUnitSearchCriteria): void {
    combineLatest([
      this.deliveryNoteItemFacade.deliveryNoteParams$,
      this.catalogSearchCriteriaFacade.getSearchCriteriaByCatalogType(CatalogSearchCriteriaType.AutomotiveAftermarket),
    ])
      .pipe(take(1))
      .subscribe(
        ([deliveryNoteParams, catalogSearchCriteria]: [DeliveryNoteParams, AutomotiveAftermarketSearchCriteria]) => {
          const searchCriteria = initialFetch
            ? new DeliveryNoteHandlingUnitSearchCriteria({
                [ListQueryParam.HandlingUnitIds]: catalogSearchCriteria[MonitoringFilterNameDictionary.HuIds],
                [ListQueryParam.BoschMaterialNumbers]:
                  catalogSearchCriteria[MonitoringFilterNameDictionary.BoschMaterialNumbers],
                [ListQueryParam.CustomerMaterialNumbers]:
                  catalogSearchCriteria[MonitoringFilterNameDictionary.CustomerMaterialNumbers],
                [ListQueryParam.BoschOrderNumbers]:
                  catalogSearchCriteria[MonitoringFilterNameDictionary.BoschOrderNumbers],
                [ListQueryParam.CustomerOrderNumbers]:
                  catalogSearchCriteria[MonitoringFilterNameDictionary.CustomerOrderNumbers],
              })
            : {
                ...filterFormSearchCriteria,
                [ListQueryParam.BoschMaterialNumbers]:
                  catalogSearchCriteria[MonitoringFilterNameDictionary.BoschMaterialNumbers],
                [ListQueryParam.CustomerMaterialNumbers]:
                  catalogSearchCriteria[MonitoringFilterNameDictionary.CustomerMaterialNumbers],
                [ListQueryParam.BoschOrderNumbers]:
                  catalogSearchCriteria[MonitoringFilterNameDictionary.BoschOrderNumbers],
                [ListQueryParam.CustomerOrderNumbers]:
                  catalogSearchCriteria[MonitoringFilterNameDictionary.CustomerOrderNumbers],
              };
          this.store.dispatch(
            new DeliveryNoteHandlingUnits({
              deliveryNoteParams,
              searchCriteria,
            }),
          );
        },
      );
  }

  setInitialState(): void {
    this.store.dispatch(new DeliveryNoteHandlingUnitsInitialState());
  }
}
